const COL_SEP = ";";
const ROW_SEP = "\r\n";

class ExportService {
    public static $inject: string[] = [
        "$translate",
        "FileSaver",
        "sitesService",
        "utilsService"
    ];

    private columnsHeaders: string[] = [];

    private $t;

    constructor(
        $translate: ng.translate.ITranslateService,
        private fileSaver,
        private sitesService,
        private utilsService
    ) {
        this.$t = $translate.instant;
    }

    public exportToCSV(data: any[], columnsHeaders: string[], fileName: string = "export-csv") {
        this.columnsHeaders = columnsHeaders;
        fileName = this.utilsService.slugify(fileName);
        const ext = "csv";
        const type = "text/csv;charset=utf-8";
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM;
        const csv = this._transformObjToCSV(data);
        const blob = new Blob([bom, csv], { type });
        this.fileSaver.saveAs(blob, `${fileName}.${ext}`);
    }

    private _transformObjToCSV(data: any[]): string {
        // set of columns keys
        const cols: string[] = data[0] ? Object.keys(data[0]) : undefined;

        // first row with columns names
        const header: string = (
            this.columnsHeaders.length
                ? this.columnsHeaders.map((col: string) => this.$t(col, { SITE: this.sitesService.siteName }))
                : cols
        ).join(COL_SEP);

        /*
         * returns a set of data rows, each row is stringifyed
         * row columns are joined with semi-colon separator
         */
        const content: string[] = cols ?
            data.map((row: any[]) =>
                cols.map((col: string) => {
                    // if value is undefined, row field is empty
                    if (!row[col]) {
                        return;
                    }
                    /*
                     * if value is a floating point number, decimal separator is replaced by a comma
                     * thousand seperator is removed to help spreadsheet app identifying field value as float
                     */
                    if (typeof row[col] === "number" && !Number.isInteger(row[col])) {
                        row[col] = new Intl.NumberFormat("fr-FR").format(row[col]).replace(/\s+/g, "");
                    }

                    return JSON.stringify(row[col])
                        .replace(/(\\r\\n|\\n)/g, " ") // replace new lines with spaces
                        // eslint-disable-next-line @typescript-eslint/quotes
                        .replace(/\\"/g, `""`); // escape double-quotes with double double-quotes
                })
                .join(COL_SEP)
            ) :
            [];

        /*
         * returns transformed rows arrays as string
         * rows are joined with Windows newline
         */
        return [
            header,
            ...content
        ].join(ROW_SEP);
    }
}

angular
    .module("thor.core.export.service", [])
    .service("exportService", ExportService);
